import { fonts } from './tokens';

// Tipografía: una familia geométrica (Outfit) en toda la consola. La jerarquía
// la dan el peso y el tracking; los labels chicos van en mayúsculas con tracking
// amplio (firma de la marca). El mono se aplica puntualmente en los datos.
export let typography: any = {
  fontFamily: fonts.sans,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: { fontWeight: 300, letterSpacing: '0.06em' },
  h2: { fontWeight: 300, letterSpacing: '0.05em' },
  h3: { fontWeight: 400, letterSpacing: '0.04em' },
  h4: { fontWeight: 500, letterSpacing: '0.02em' },
  h5: { fontWeight: 500, letterSpacing: '0.02em' },
  h6: { fontWeight: 500, letterSpacing: '0.01em' },
  subtitle1: { fontWeight: 500 },
  subtitle2: { fontWeight: 500, letterSpacing: '0.02em' },
  body1: { fontWeight: 400 },
  body2: { fontWeight: 400 },
  button: {
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'none',
  },
  caption: { fontWeight: 400, letterSpacing: '0.01em' },
  overline: {
    fontWeight: 600,
    letterSpacing: '0.16em',
    textTransform: 'uppercase',
  },
};
